import type { ReactNode } from 'react';

/**
 * The Selection module's page box (T-0142; shared with the Vendor
 * intelligence steps in T-0272): the engagement pane's height, the viewport
 * minus the 56px top bar and the shell's 48px of vertical padding, clipped
 * so the workspace inside scrolls itself.
 */
export function SelectionFrame({ children }: { children: ReactNode }) {
  return (
    <div className="h-[calc(100vh-56px-48px)] min-h-[480px] overflow-hidden rounded-card border border-ink-100 bg-paper-0">
      {children}
    </div>
  );
}
